/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateEtcCardIssuanceRequest400Response
 */
export interface CreateEtcCardIssuanceRequest400Response {
    /**
     * 
     * @type {string}
     * @memberof CreateEtcCardIssuanceRequest400Response
     */
    'code': CreateEtcCardIssuanceRequest400ResponseCodeEnum;
}

export const CreateEtcCardIssuanceRequest400ResponseCodeEnum = {
    validationError: 'etc-validation-error',
    cardNameDuplicate: 'etc-card-name-duplicate',
    cardLimitExceeded: 'etc-card-limit-exceeded',
    creditInsufficient: 'etc-credit-insufficient',
    issuerPermissionDenied: 'etc-issuer-permission-denied',
    issuerNotFound: 'etc-issuer-not-found',
    holderInvalidRole: 'etc-holder-invalid-role',
    holderNotFound: 'etc-holder-not-found',
    systemError: 'etc-system-error'
} as const;

export type CreateEtcCardIssuanceRequest400ResponseCodeEnum = typeof CreateEtcCardIssuanceRequest400ResponseCodeEnum[keyof typeof CreateEtcCardIssuanceRequest400ResponseCodeEnum];


